<template>
  <div class="q-pa-lg" style="padding-bottom: 60px;">

    <div class="box">
      <el-form size="small">
        <el-form-item>
          <el-input style="width: 200px;" v-model.trim="cardTypeName" placeholder="资源类别名称" />
        </el-form-item>
      </el-form>
      <div class="btns">
        <el-button @click="list(1)" plain type="primary" size="small" icon="el-icon-search">搜索</el-button>
        <!--<el-button @click="download" type="success" size="small" icon="el-icon-download">导出</el-button>-->
      </div>
    </div>
    <el-table ref="multipleTable" :data="tableData" :row-style="{height:'40px',textAlign:'center'}"
              :cell-style="{height:'5px,0',textAlign:'center'}"
              :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}" border
              style="width: 100%;margin-top: 1%;height: 70vh">
      <el-table-column type="selection">
      </el-table-column>
      <el-table-column prop="id" label="编号" min-width="180">
      </el-table-column>
      <el-table-column prop="cardTypeName" label="资源类别名称" min-width="180">
      </el-table-column>
      <el-table-column prop="cardTypeCode" label="资源类别编码" min-width="180">
      </el-table-column>
      <el-table-column prop="cardType" label="字表名称" min-width="180">
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" min-width="180">
      </el-table-column>
    </el-table>
    <pagination class="text-center" ref="pagination" v-bind:list="list" v-bind:itemCount="8"></pagination>
  </div>
</template>

<script>
import Pagination from '../../../components/pagination'

export default {
  name: 'resourcesList',
  components: {
    Pagination
  },

  mounted: function () {
    let _this = this
    _this.$refs.pagination.size = 10
    //_this.list(1);
  },

  data() {
    return {
      maxHeight: 500,
      tableData: [],
      cardTypeName: '',
      cardjs: require('../../../api/card')
    }
  },
  created() {
    // this.initData({});
  },
  methods: {
    list(page) {
      let _this = this
      _this.maxHeight = _this.$listenHeight.getBodyHeight()
      if (_this.selectDatetimeed === null) {
        _this.selectDatetimeed = ''
      }
      if (_this.selectDatetimest === null) {
        _this.selectDatetimest = ''
      }
      let data={
        current: page,
        size: _this.$refs.pagination.size,
        cardTypeName: _this.cardTypeName
      }
      _this.cardjs.getResourceList(data)
        .then(response => {
          _this.tableData = response.data.data.rows
          _this.$refs.pagination.render(page, response.data.data.total)
        })
    },
    /*deleteResources(type) {
            let _this = this;
            _this.$confirm('此操作将删除该资源, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                //删除资源信息
                _this.$ajax.post(process.env.VUE_APP_SERVER + "/system/deleteResources", type).then(res => {
                    if (res.data.code === "0") {
                        _this.$message({
                            type: 'success',
                            message: res.data.data
                        });
                        _this.list(1)
                    } else {
                        _this.$message({
                            type: 'success',
                            message: res.data.msg
                        });
                    }

                }).catch(error => {
                    _this.$swal(error)
                })

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },*/
    /*download() {
      let _this = this
      window.location.href = process.env.VUE_APP_SERVER + '/system/downloadfilezy?cardTypeName=' + _this.cardTypeName
    }*/
  }
}
</script>

<style scoped>
.box {
  display: flex;
  flex-direction: row;
}
.btns {
  margin-left: 10px;
}
._select {
  width: 20%;
  height: 34px;
}
.pup {
  float: right;
}
.col-md-3 {
  float: left;
}
</style>
<style lang="less" scoped>
/deep/.el-table .el-table__cell {
  padding: 0px !important;
}
/deep/thead.has-gutter {
  height: 40px;
}

/* 设置滚动条宽度和高度 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  width: 10px; /* 横向滚动条 */
  height: 10px; /* 纵向滚动条 必写 */
}
/* 设置滚动条样式 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #dde;
  border-radius: 3px;
}
::v-deep .el-table {
  height: 88%;
.el-table__body-wrapper {
  height: calc(100% - 48px) !important; // 表格高度减去表头的高度
overflow-y: auto;
}
}

</style>